import React from "react";
import BotResponseLayout from "./BotResponseLayout";

function BotExplainWithImage({ text, points, imgSrc, imgSrc1, onBack, actionProvider }) {
  return (
    <BotResponseLayout actionProvider={actionProvider}>
      {/* Image */}
      {imgSrc && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <img
            src={imgSrc}
            alt="Section Preview"
            style={{
              maxWidth: "100%",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          />
        </div>
      )}

      {imgSrc1 && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <img
            src={imgSrc1}
            alt="Section Preview"
            style={{
              maxWidth: "100%",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          />
        </div>
      )}

      {/* Explanation */}
      <p style={{ fontSize: "15px", lineHeight: "1.5", color: "#333" }}>
        {text}
      </p>

      {/* Bullet Points */}
      {points && (
        <ul style={{ paddingLeft: "20px", marginTop: "6px", color: "#333" }}>
          {points.map((pt, idx) => (
            <li key={idx} style={{ marginBottom: "6px" }}>
              {pt}
            </li>
          ))}
        </ul>
      )}

      {/* Back button */}
      {
        onBack && <button
        onClick={onBack}
        style={{
          width: '100%',
          marginTop: "10px",
          padding: "10px 15px",
          borderRadius: "6px",
          backgroundColor: "#4B5563",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        ⬅ Back
      </button>
      }
      
    </BotResponseLayout>
  );
}

export default BotExplainWithImage;
